import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useAddVideoMutation } from "../../redux/features/videos/videosAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import Error from "../../components/Error";
import usePageTitle from "../../utils/usePageTitle";

export default function AddVideo() {
  usePageTitle("Add Video");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const [addVideo, { isLoading, error }] = useAddVideoMutation();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [views, setViews] = useState("");
  const [duration, setDuration] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    addVideo({
      title,
      description,
      url,
      views,
      duration,
      createdAt: new Date(createdAt).toISOString(),
    });

    navigate("/admin/videos");
  };

  return (
    <div
      style={{
        minWidth: "50%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="container relative"
    >
      <h2 className="text-center text-3xl font-bold text-cyan">
        Add New Video
      </h2>
      <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <label
              htmlFor="title"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Title
            </label>
            <input
              id="title"
              name="title"
              type="name"
              autoComplete="name"
              required
              className="login-input rounded-md mt-1"
              placeholder="Video Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="description"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
            >
              Description
            </label>
            <input
              id="description"
              name="description"
              type="description"
              autoComplete="description"
              required
              className="login-input rounded-md mt-1"
              placeholder="Video Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="url"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
            >
              URL
            </label>
            <input
              id="url"
              name="url"
              type="url"
              autoComplete="url"
              required
              className="login-input rounded-md mt-1"
              placeholder="Video URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="Views"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
            >
              Views
            </label>
            <input
              id="views"
              name="views"
              type="text"
              autoComplete="views"
              required
              className="login-input rounded-md mt-1"
              placeholder="Views"
              value={views}
              onChange={(e) => setViews(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="Duration"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
            >
              Duration
            </label>
            <input
              id="duration"
              name="duration"
              type="name"
              autoComplete="duration"
              required
              className="login-input rounded-md mt-1"
              placeholder="Video Duration"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />
          </div>

          <div>
            <label
              htmlFor="createdAt"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4"
            >
              Created At
            </label>
            <input
              style={{ color: "lightslategray", colorScheme: "dark" }}
              id="createdAt"
              name="createdAt"
              type="date"
              autoComplete="createdAt"
              required
              className="login-input rounded-md mt-1"
              placeholder="Created At"
              value={createdAt}
              onChange={(e) => setCreatedAt(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-end gap-x-2">
          <button
            type="submit"
            disabled={isLoading}
            className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          >
            Save
          </button>

          <Link
            to="/admin/videos"
            type="submit"
            disabled={isLoading}
            className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Cancel
          </Link>
        </div>
        {error && <Error message={error.message} />}
      </form>
    </div>
  );
}
